import { PermissionUserType, useGetProfileQuery } from 'src/graphql/generated';

// ----------------------------------------------------------------------
export function useHasPermission() {
  const profileRequestResponse = useGetProfileQuery();
  const connectedStoreId = profileRequestResponse.data?.me?.connectedStore?.id;

  const storePermissions = profileRequestResponse.data?.me?.permissions.filter(
    (permission) => connectedStoreId === permission.store.id
  );

  const hasAdminPermission = storePermissions?.some(
    (permission) => permission.userType === PermissionUserType.Admin
  );
  const hasEmployeePermission = storePermissions?.some(
    (permission) => permission.userType === PermissionUserType.Employee
  );
  const hasSellerPermissions = storePermissions?.some(
    (permission) => permission.userType === PermissionUserType.Seller
  );

  return {
    hasAdminPermission,
    hasEmployeePermission,
    hasSellerPermissions,
    storePermissions,
    isLoading: profileRequestResponse?.loading,
    data: profileRequestResponse?.data,
  };
}
